import { render, staticRenderFns } from "./messageDialog.vue?vue&type=template&id=acdf50da&scoped=true"
import script from "./messageDialog.vue?vue&type=script&lang=js"
export * from "./messageDialog.vue?vue&type=script&lang=js"
import style0 from "./messageDialog.vue?vue&type=style&index=0&id=acdf50da&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdf50da",
  null
  
)

export default component.exports